<div class="left">
    <ng-container>
        <app-popup-content>
            <ng-container [ngTemplateOutlet]="menuContent"></ng-container>
        </app-popup-content>
    </ng-container>

    <!-- Не забывайте обрезать строки, которые здесь оказываются -->
    <ng-content select="[fui-table-header-title]"> </ng-content>
</div>
<div *ngIf="!isLoading" class="right flex flex-row gap-x-2">
    <div class="flex flex-row items-center gap-x-2">
        <ng-container *ngIf="table?.selection?.selected?.length > 0">
            <div class="selected">{{ dictionary.system_selected }}: {{ table?.selection?.selected?.length }}</div>
        </ng-container>
        <ng-container *ngIf="hasGlobalButtons$ | async">
            <ng-container *ngFor="let button of table.globalButtons$ | async">
                <fui-button
                    (clickEvent)="
                        button.click
                            ? table.callParent(
                                  button.click,
                                  button.records === 'one' ? table.selection.selected[0] : table.selection.selected,
                                  $event
                              )
                            : null
                    "
                    [label]="button.name"
                    [disabled]="table.isDisabledButton(button)"
                    [color]="button?.notPrimary ? 'soft-outline' : 'soft'"
                    [icon]="button.icon"
                    height="slim"
                >
                </fui-button>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="(hasGlobalMenuButtons$ | async) === true && (table.emptyResult$ | async) === false">
            <fui-button
                [matMenuTriggerFor]="globalMenu"
                [title]="dictionary.system_actions"
                type="button-icon"
                color="soft-outline"
                height="slim"
                icon="dots-vertical"
            >
            </fui-button>
            <mat-menu #globalMenu="matMenu">
                <ng-container [ngTemplateOutlet]="menuContent"></ng-container>
            </mat-menu>
        </ng-container>
    </div>
    <ng-container *ngIf="(hasGlobalMenuButtonsPanel$ | async) === true || forceButtonPanel === true">
        <fui-buttons-panel
            [buttons]="globalMenuButtonsPanel$ | async"
            (buttonClick)="table?.callParent($event.name, null, $event)"
        >
            <ng-content select="[buttons-panel-extra]"></ng-content>
        </fui-buttons-panel>
    </ng-container>
    <ng-content select="[table-header-right-block]"> </ng-content>
</div>
<div *ngIf="isLoading" class="right flex flex-row gap-x-2">
    <div class="flex-none"><div class="skeleton w-20 h-6"></div></div>
    <div class="flex-none"><div class="skeleton w-6 h-6"></div></div>
    <div class="flex-none"><div class="skeleton w-6 h-6"></div></div>
</div>

<ng-template #menuContent>
    <div class="context-menu">
        <ng-container *ngFor="let button of globalMenuButtons$ | async">
            <ng-container *ngIf="button?.isShowInHeader ? button?.isShowInHeader(table.customFilter) : true">
                <button
                    class="context-menu-item"
                    type="button"
                    mat-menu-item
                    [ngClass]="{
                        divider: button.icon.indexOf('delete') !== -1,
                        delete: button.icon.indexOf('delete') !== -1,
                    }"
                    [disabled]="table.isDisabledButton(button)"
                    (click)="
                        button.click
                            ? table.callParent(
                                  button.click,
                                  button.records === 'one' ? table.selection.selected[0] : table.selection.selected,
                                  $event
                              )
                            : null
                    "
                >
                    <div class="flex flex-row">
                        <mat-icon aria-hidden="true" fontSet="mdi" [fontIcon]="'mdi-' + button.icon">
                        </mat-icon>
                        <span>{{ button.name }}</span>
                    </div>
                </button>
            </ng-container>
        </ng-container>
    </div>
</ng-template>
